import { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { noop } from 'lodash/fp';
import { Button, ButtonSize } from 'app/components/core/Button';
import { ConfirmationButton } from 'app/components/core/ConfirmationButton';
import {
    Dialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalActions
} from 'app/components/core/Modal';
import * as styles from './ConfirmationDialog.css';

const cx = classnames.bind(styles);

function useAutoClose(isProcessing, onClose) {
    const [hasStartedProcessing, setProcessing] = useState(false);

    useEffect(() => {
        if (isProcessing) {
            setProcessing(true);
        } else if (hasStartedProcessing) {
            onClose();
        }
    }, [isProcessing, hasStartedProcessing, setProcessing, onClose]);
}

export function ConfirmationDialog({
    className,
    title,
    confirm,
    hint,
    isProcessing = false,
    children = null,
    onSubmit = noop,
    onClose = noop,
    ...props
}) {
    const { t } = useTranslation();

    useAutoClose(isProcessing, onClose);

    return (
        <Dialog onClose={onClose} className={cx('base', className)} {...props}>
            <ModalHeader icon="status-warning" className={cx('header')}>
                <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody>{children}</ModalBody>
            <ModalActions as="footer">
                <Button size={ButtonSize.MEDIUM} onClick={onClose}>
                    {t('common:cancel')}
                </Button>
                <ConfirmationButton
                    icon="delete"
                    label={confirm}
                    hint={hint}
                    isProcessing={isProcessing}
                    onClick={onSubmit}
                />
            </ModalActions>
        </Dialog>
    );
}
